/*
 * Map Messages
 *
 * This contains all the text for the Map component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  elevationButton: {
    id: 'app.components.ElevationChart.elevationButton',
    defaultMessage: 'Elevation',
  },
  elevationLabel: {
    id: 'app.components.ElevationChart.elevationLabel',
    defaultMessage: 'Elevation (m)',
  },
  distanceLabel: {
    id: 'app.components.ElevationChart.distanceLabel',
    defaultMessage: 'Distance (km)',
  },
  elevation: {
    id: 'app.components.ElevationChart.elevation',
    defaultMessage: 'Elevation',
  },
  distance: {
    id: 'app.components.ElevationChart.distance',
    defaultMessage: 'Distance',
  },
  gradient: {
    id: 'app.components.ElevationChart.gradient',
    defaultMessage: 'Gradient',
  },
  supportersOnly: {
    id: 'app.components.ElevationChart.supportersOnly',
    defaultMessage:
      'Flat route, slight slope, climb? As a supporter you will find out in advance with an interactive elevation profile here',
  },
  supporterButton: {
    id: 'app.components.SubscriptionModal.header',
    defaultMessage: 'Become a RunnerMaps Supporter',
  },
  noRoute: {
    id: 'app.components.ElevationChart.noRoute',
    defaultMessage: 'No route in view',
  },
  ascent: {
    id: 'app.components.ElevationChart.ascent',
    defaultMessage: 'Ascent {ascent} m',
  },
});
